const state = {
    title: '',
    look: true,
    roleForm: {},
    authority: []
};

const mutations = {
    setRoleTitle(state, payload) {
        state.roleTitle = payload.title;
        state.look = payload.look;
    },
    setRowData(state, payload) {
        state.roleForm = payload.form;
        state.authority = payload.authority;
    },
};

const actions = {

};

export default {
    namespaced: true,
    state,
    mutations,
    actions
}